import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type { AiCostsSort } from '@UI/Pages/Administration/AiCosts/Filters/AiCostsFilterView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { SelectButton } from '@verclam/ui-kit';

type SortOption = { readonly label: string; readonly value: AiCostsSort };

const SORT_OPTIONS: readonly SortOption[] = [
	{ label: 'Plus récents', value: 'recent' },
	{ label: 'Plus chers', value: 'cost' },
];

const isSort = (value: unknown): value is AiCostsSort => value === 'recent' || value === 'cost';

/** Switches the list between the most recent items and the most expensive ones. */
const SortSwitch: React.FC = () => {
	const filters = useSignalValue(aiCostsFiltersSignal);

	const handleChange = React.useCallback((value: unknown) => {
		if (isSort(value)) {
			setAiCostsFilters(aiCostsFiltersSignal.peek().setSort(value));
		}
	}, []);

	return (
		<SelectButton
			name="aiCostsSort"
			label="Tri de la liste"
			isLabelHidden
			options={SORT_OPTIONS}
			value={filters.sort}
			allowEmpty={false}
			onChange={handleChange}
		/>
	);
};

export default SortSwitch;
